
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

export const HotelCardsSlider = () => {
  const $sliderWrapper = $('.js-hotel-benefits-cards__slider');
  if ( !$sliderWrapper.length ) {
    return
  }

  $(document).ready(function() {
    new Swiper('.js-hotel-benefits-cards__slider', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      centeredSlides: true,
      // pagination: {
      //   el: '.js-otherRestaurants__pagination',
      //   clickable: true,
      // },

      // Navigation arrows

      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
        },

        992: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },

      navigation: {
        nextEl: '.js-hotel-benefits-cards__nextSlide',
        prevEl: '.js-hotel-benefits-cards__prevSlide',
      },
      pagination: {
        el: '.js-hotel-benefits-cards__pagination',
      },
    })

  });
}
